/** Private */

export default {
    name: 'ib-tab-title',

    props: {
        vnode: Object,
        appearance: String
    },

    data() {
        return {
            active: false
        };
    },

    computed: {
        data() {
            const componentOptions = this.vnode.componentOptions;
            return componentOptions ? componentOptions.propsData : {};
        },

        title() {
            const componentOptions = this.vnode.componentOptions;
            if (componentOptions) {
                const slot = (this.vnode.componentOptions.children||[]).find(child => child.data?.slot == 'title');
                return slot
                    ? slot.tag == 'template'
                        ? slot.children
                        : [slot]
                    : [this.data.title];
            } else {
                return [];
            }
        },

        id() {
            return this.data.id || '_tab' + this._uid;
        },

        href() {
            return this.data.href || (this.data.route ? this.$router.resolve(this.data.route, this.$route).href : null);
        },

        disabled() {
            return this.data.disabled != null && this.data.disabled !== false;
        }
    },

    render(h) {
        const data = this.data;
        const title = this.title;
        const badge = data.badge != null;

        // clear tabs have duplicate content in bold to prevent size change on focus
        const inner = this.appearance != 'clear' ? title : title.concat(h('span', {
            attrs: {
                'class': '_tabci'
            }
        }, title));

        return h(badge ? 'ib-badge2' : 'a', {
            attrs: {
                'tag': badge ? 'a' : null,
                'value': data.badge,
                'role': 'tab',
                'class': '_tabt'
                    + (data.tone ? ' ' + data.tone : '')
                    + (data.align ? ' _a' + data.align : '')
                    + (badge ? '' : this.active ? ' _tabtc' : ' _tabtc _tabtn'),
                'disabled': this.disabled,
                'id': this.id,
                'href': this.href,
                'aria-label': data.title,
                'aria-selected': this.active
            },
            on: {
                dragstart: e => {
                    e.preventDefault();
                },
                ...this.disabled ? {} : {
                    click: this.click
                }
            }
        }, badge
            ? [h('span', { 'class': ' _tabtc' + (this.active ? '' : ' _tabtn') }, inner)]
            : inner
        );
    },

    methods: {
        click() {
            this.$emit('click', this);
        }
    }
}
